import React from 'react';
import { Link as ReactRouterLink } from "react-router-dom";
import classes from './Link.module.scss';
import PropTypes from "prop-types";

export const Link = ({to, children, type, inherit, external, onClick}) => {
    return (
        <span
            data-testid={'link-wrapper'}
            className={`${classes['link']} ${classes[`${type}-link`]} ${inherit ? classes['inherit'] : ''}`}
            onClick={onClick || undefined}
        >
            {
                external ?
                    <a href={to} target={'_blank'} rel="noreferrer">{children}</a> :
                    <ReactRouterLink to={to}>{children}</ReactRouterLink>
            }
        </span>
    );
};

Link.propTypes = {
    /**
     * relative pathname exactly the same as React Router's Link
     */
    to: PropTypes.string.isRequired,
    /**
     * represents the style of the link
     */
    type: PropTypes.oneOf(['primary', 'secondary']),
    /**
     * set true to inherit styles from parent
     */
    inherit: PropTypes.bool,
    /**
     * set true in order to open an external link in a new tab (NO relative paths)
     */
    external:PropTypes.bool,
    /**
     * Any React/HTML node as link text
     */
    children: PropTypes.node,
    /**
     * onClick function to prevent the link default behavior
     */
    onClick: PropTypes.func
}

Link.defaultProps = {
    to: undefined,
    type: 'primary',
    inherit: false,
    external: false,
    children: undefined,
    onClick: undefined
}